import { RUNNING_RUNS_LIMIT } from "@agentdash/shared";
import type { RunsQueryOpts } from "../lib/api-client.js";

/**
 * The running-runs query the Live view subscribes to *and* the one the
 * /api/live snapshot frame seeds (useLiveSync). `limit` is part of the cache
 * key, so both sides must build it from this one object: a snapshot written
 * under any other key lands on a query nothing is subscribed to.
 */
export const LIVE_RUNNING_RUNS: RunsQueryOpts = {
  status: "running",
  limit: RUNNING_RUNS_LIMIT,
};

export const queryKeys = {
  runs: (opts?: RunsQueryOpts) =>
    ["runs", opts ?? {}] as const,
  run: (traceId: string) => ["run", traceId] as const,
  stats: (days: number) => ["stats", days] as const,
};
